import { useId } from '@reach/auto-id';
import { Radio, useFieldApi } from 'informed';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

const ToggleOption = ({
  children,
  disabled,
  id,
  isDefault,
  groupId,
  value,
}) => {
  const fieldApi = useFieldApi(groupId);
  const elementId = useId(id);

  useEffect(() => {
    if (isDefault) {
      fieldApi.setValue(value);
    }
  }, [fieldApi, isDefault, value]);

  return (
    <div>
      <Radio disabled={disabled} id={elementId} value={value} />
      <label htmlFor={elementId}>{children}</label>
    </div>
  );
};

ToggleOption.defaultProps = {
  disabled: false,
  groupId: '',
  id: null,
  isDefault: false,
};

ToggleOption.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  groupId: PropTypes.string,
  id: PropTypes.string,
  isDefault: PropTypes.bool,
  value: PropTypes.string.isRequired,
};

export default ToggleOption;
